
import Vue from 'vue';
import AnimatedCircle from './AnimatedCircle.vue';

interface Props {
  title: string | number;
  desc: string;
  icon: string;
  connector: boolean;
  percent: number;
  totalPercent: number;
  mode?: string;
}

interface Data {
  diameterSize: number;
  strokeSize: number;
}

interface Methods {
  getWidth: () => void;
}

interface Computed {
  description: string;
  iconDifficulty: string;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    AnimatedCircle,
  },
  data() {
    return {
      diameterSize: 145,
      strokeSize: 10,
    };
  },
  props: {
    title: { type: [String, Number] },
    desc: String,
    icon: String,
    connector: { type: Boolean, default: false, required: false },
    percent: { type: Number, default: 0 },
    totalPercent: { type: Number, required: false },
    mode: { type: String, required: false },
  },
  computed: {
    iconDifficulty() {
      switch (this.icon) {
        case 'Lihtne':
          return 'chart-lihtne';
        case 'Keeruline':
          return 'chart-keeruline';
        default:
          return 'chart-keskmine';
      }
    },
    description() {
      switch (this.desc) {
        case 'h':
          return this.title > 1 ? 'tundi' : 'tund';
        case 'min':
          return this.title > 1 ? 'minutit' : 'minut';
        default:
          return this.desc;
      }
    },
  },
  methods: {
    getWidth() {
      this.diameterSize = window?.screen?.width > 1300 ? 146 : 106;
      this.strokeSize = window?.screen?.width > 1300 ? 10 : 6;
    },
  },
  mounted() {
    this.getWidth();
    document?.addEventListener('resize', this.getWidth);
  },
  beforeDestroy() {
    document?.removeEventListener('resize', this.getWidth);
  },
});
